import React from 'react';


export const SNS = props => {
    return (
        <img className={props.className} src={require('../../../../resources/images/aws_icons/sns.png')} />
    )
};
